import { render, staticRenderFns } from "./printSwitching.vue?vue&type=template&id=6a8124bc&"
import script from "./printSwitching.vue?vue&type=script&lang=ts&"
export * from "./printSwitching.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports